import { TheMask } from 'vue-the-mask'

export default {
  name: 'CollaborationInput',
  props: {
    value: String,
    error: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    mask: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  components: {
    TheMask,
  },
  setup() {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}
